import { NavLink } from "react-router-dom";
import arrow from "../../../assets/images/icons/arrow-right.svg";
import first from "../../../assets/images/welcome/first-mob.png";
import defStyles from "./Intro.module.scss";
import nomadStyles from "./Intro.nomad.module.scss";
import { useTranslation } from "react-i18next";
import intro_pic from "../../../assets/images/intro_welcome.png";
import rockets_intro_pic from "../../../assets/images/rockets_intro_welcome.png";

const styles =
  process.env.REACT_APP_BRAND === "nomad" ? nomadStyles : defStyles;

const Intro = ({ onClickNext }) => {
  const { t } = useTranslation(["welcome", "main", "rockets_welcome"]);

  const isRockets = process.env.REACT_APP_BRAND === "rockets";

  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.wrapper} ${isRockets && styles.reverse_direction }`}>
        <div>
          <div className={styles.title}>
            {isRockets ? (
              <>
                {" "}
                {t("rockets_welcome:welcome_title")}
                <span className={styles.yellow}>Parik24</span>{" "}
              </>
            ) : (
              <>
                <span className={styles.yellow}>PM-Pass</span>{" "}
                {t("intro_title")}
              </>
            )}
          </div>
          <div className={styles.info}>
            <div
              className={styles.txt}
              dangerouslySetInnerHTML={{
                __html: isRockets
                  ? t("rockets_welcome:welcome_text")
                  : t("intro_text2"),
              }}
            ></div>
          </div>
          <div onClick={onClickNext}>
            <button className={styles.btn}>
              {isRockets ? t("rockets_welcome:welcome_button") : t("main:next")}
            </button>
          </div>
        </div>

        <img src={isRockets ? rockets_intro_pic : intro_pic} className={styles.intro_pic} alt="intro" />
      </div>
    </div>
  );
};

export default Intro;
